import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CreateAccountPage } from './create-account.page';
import {TranslateModule} from '@ngx-translate/core';
import { LodeUserFormComponentModule } from '../../components/lode-user-form/lode-user-form.component.module';
import { SettingsGuardService } from '../../angular-wallet-base/services/settingsguard.service';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild([{path: '', component: CreateAccountPage, canDeactivate: [SettingsGuardService]}]),
    TranslateModule,
    LodeUserFormComponentModule
  ],
  declarations: [CreateAccountPage]
})
export class CreateAccountPageModule {}
